import { z } from 'zod';

import { defineStandalone } from '@apps/web/features/phoebe_chat_v3/registry/types';
import { AssistantTextMessage } from '@apps/web/features/phoebe_chat_v3/ui/primitives/chat_text_message';

export const assistantTextPayloadSchema = z.object({
    text: z.string().max(100_000),
});

export const assistantTextDefinitions = {
    assistant_text: defineStandalone('assistant_text', {
        disposition: 'render',
        schema: assistantTextPayloadSchema,
        malformed: {
            kind: 'placeholder',
            customerCopy: 'A response could not be displayed.',
        },
        evidence: null,
        group: null,
        render(payload, occurrence, context) {
            return (
                <AssistantTextMessage
                    text={payload.text}
                    occurrence={occurrence}
                    organizationTimeZone={context.organizationTimeZone}
                />
            );
        },
    }),
} as const;

export const assistantTextContractFixtures = {
    valid: {
        type: 'assistant_text',
        text: 'I found the information you requested.',
    },
    malformed: {
        type: 'assistant_text',
        text: false,
    },
} as const;
